import { API_URL } from "../config/constants";

import axios from "axios";
import axiosRetry from 'axios-retry'; 
import { IS_NATIVE, getAccessToken, setAccessToken, clearAccessToken } from "../services/auth/nativeAuth";

export default function uploadServer ({
    endpoint,
    body = {},
    params = {},
    needAuthenticate = true,
    handleError = true,
    showLoading = true,
    retryIfFailed = false,
    autoRetryTimes = 2,
    timeout = null,
}) {
    const api_url_end = API_URL + endpoint;
    const axiosClient = axios.create({})
    if (retryIfFailed) {
        axiosRetry(axiosClient, {
          retries: autoRetryTimes,
          retryDelay: retryCount => {
            return retryCount * 2000;
          },
          retryCondition: error => {
            return error.response.status >= 500 || error.response.status === 409;
          },
        });
    }

    axiosClient.interceptors.request.use((config) => {
        if (needAuthenticate) {
                config.withCredentials = true;
                if (IS_NATIVE && getAccessToken()) config.headers.Authorization = `Bearer ${getAccessToken()}`;
        }
        return config;
    });

    
    return axiosClient.post(api_url_end, body, {
        params: params,
        headers: get_headers('POST')
    }).then( response => {
        return handleResponse(response)
    }).catch( error => {
        return handleResponse(error?.response)
    })
}

const get_headers = (method = "POST") => {
    if(method === "POST")
        return { 
            'Content-Type': 'multipart/form-data', 
            'Accept': 'application/json', 
            'charset': 'utf-8'
        }
    else if(method === "GET")
        return {}
    
}

const handleResponse = (response) => {
    if (response == null) return { success: false, data: null };
    if (IS_NATIVE) {
        // every login / refresh_session response carries the (re)issued session token
        if (response.data?.access_token) setAccessToken(response.data.access_token);
        else if (response.status === 401) clearAccessToken();
    }
    if (response.success === false || response.status >= 400 || response?.data?.detail) return { success: false, error: response?.data?.detail ? response?.data?.detail : response?.statusText };
    return { success: true, data: response.data };
}